import * as React from "react";
import Svg, { G, Rect, Path } from "react-native-svg";

export default function SocialIconYoutube() {
  return (
    <Svg
      style={{
        flex: 1,
        maxWidth: 30,
        maxHeight: 30,
        width: 64,
        height: 64,
      }}
      height="100%"
      width="100%"
      top={0}
      left={0}
      viewBox="0 0 400 400"
      id="Layer_1"
      viewBox="0 0 500 500"
      xmlSpace="preserve"
      xmlns="http://www.w3.org/2000/svg"
    >
      <G transform="translate(0 -552.362)">
        <Rect
          height={500}
          rx={250}
          ry={250}
          width={500}
          x={0}
          y={552.36218}
          fill="#cc181e"
          fillOpacity={1}
          stroke="none"
        />
        <Path
          d="M249.9 682.312s-67.152-.02-111.925 3.45c-6.252.77-19.891.866-32.075 14.45-9.583 10.363-12.7 33.875-12.7 33.875S90 761.72 90 789.337v25.9c0 27.638 3.2 55.225 3.2 55.225s3.107 23.532 12.7 33.875c12.184 13.584 28.178 13.18 35.3 14.6 25.597 2.62 108.775 3.425 108.775 3.425s67.242-.119 112.025-3.55c6.252-.8 19.927-.866 32.1-14.45 9.583-10.343 12.675-33.9 12.675-33.9S410 842.865 410 815.237v-25.875c0-27.628-3.225-55.275-3.225-55.275s-3.082-23.512-12.675-33.875c-12.174-13.584-25.848-13.68-32.1-14.45-44.783-3.471-111.925-3.45-111.925-3.45h-.175zm-39.875 60l100.05 60.025-100.05 60.025v-120.05z"
          opacity={1}
          fill="#fff"
          fillOpacity={1}
          stroke="none"
        />
      </G>
    </Svg>
  );
}
